/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditoruntitledsection3Inputs */

const en_menueditoruntitledsection3 = /** @type {(inputs: Menueditoruntitledsection3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled section`)
};

const de_menueditoruntitledsection3 = /** @type {(inputs: Menueditoruntitledsection3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereich ohne Titel`)
};

/**
* | output |
* | --- |
* | "Untitled section" |
*
* @param {Menueditoruntitledsection3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditoruntitledsection3 = /** @type {((inputs?: Menueditoruntitledsection3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditoruntitledsection3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditoruntitledsection3(inputs)
	return de_menueditoruntitledsection3(inputs)
});
export { menueditoruntitledsection3 as "menuEditorUntitledSection" }